import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { homeFor } from "../../lib/auth";

/** Contractor-only subtree. Admins and user admins get bounced to their own home. */
export const Route = createFileRoute("/_authed/_contractor")({
  beforeLoad: ({ context }) => {
    const role = context.user?.role;
    if (role !== "CONTRACTOR") throw redirect({ to: role ? homeFor(role) : "/login" });
  },
  component: () => <Outlet />,
});
